export const getPageList = (pathname) => [
  {
    path: '/',
    name: '首页',
    special: false,
    active: pathname === '/',
  },
  {
    path: '/service',
    name: '服务项目',
    special: true,
    active: pathname === '/service',
  },
  {
    path: '/business',
    name: '业务方案',
    special: false,
    active: pathname.includes('/business'),
  },
  {
    path: '/write',
    name: '标准编制',
    special: false,
    active: pathname.includes('/write'),
  },
  {
    path: '/certificate',
    name: '资质证书',
    special: false,
    active: pathname.includes('/certificate'),
  },
  {
    path: '/news',
    name: '新闻动态',
    special: false,
    active: pathname.includes('/news'),
  },
  {
    path: '/check',
    name: '报告查询',
    special: false,
    active: pathname.includes('/check'),
  },
];
